const InputField = ({ icon: Icon, label, value, onChange, placeholder, type = "text" }) => (
  <div className="mb-4">
    <label className="block text-brand-neutral-700 text-xs sm:text-sm font-semibold mb-2 pl-1">
      {label}
    </label>
    <div className="relative group">
      <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-brand-neutral-400 group-focus-within:text-brand-navy transition-colors">
        <Icon size={18} />
      </div>
      <input
        type={type}
        className="w-full bg-white border border-brand-neutral-200 text-brand-neutral-800 text-sm sm:text-base rounded-xl focus:ring-2 focus:ring-brand-navy/30 focus:border-brand-navy hover:border-brand-navy/50 hover:shadow-md block pl-11 pr-4 py-3 sm:py-3.5 shadow-sm placeholder-brand-neutral-400 transition-all duration-200 outline-none text-left"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  </div>
);

export default InputField;
